// src/utils/pdfSafeText.js
// pdf-lib's built-in fonts (Helvetica etc.) can only draw the WinAnsi
// character set, and throw on anything else - so a single unusual character
// in a comment stopped the whole marked PDF being built, and with it the
// head marker's approve-and-send (Jo's TH5 comment bank had "full-time"
// with a Unicode hyphen, U+2010, 2026-10-27). Text is swapped for the
// nearest character the font has; anything with no equivalent becomes "?".

const REPLACEMENTS = {
  '‐': '-', '‑': '-', '‒': '-', '⁃': '-', '−': '-', '﹣': '-', '－': '-',
  '―': '—',
  '′': "'", '‵': "'", '″': '"', '‶': '"',
  ' ': ' ', ' ': ' ', ' ': ' ', ' ': ' ', ' ': ' ', ' ': ' ',
  ' ': ' ', ' ': ' ', ' ': ' ', ' ': ' ', ' ': ' ', '　': ' ',
  '​': '', '‌': '', '‍': '', '⁠': '', '﻿': '',
  '≤': '<=', '≥': '>=', '≠': '!=', '≈': '~',
  '→': '->', '←': '<-', '⇒': '=>',
  '●': '•', '▪': '•', '◦': '•', '∙': '•',
  '✓': 'v', '✔': 'v', '✗': 'x', '✘': 'x'
};

// Makes a pdf-lib font swap unsupported characters instead of throwing.
// drawText and the width measurements all go through these two methods.
export const makeFontPdfSafe = (font) => {
  const supported = new Set(font.getCharacterSet());
  const clean = (text) => {
    let out = '';
    for (const ch of String(text ?? '')) {
      const code = ch.codePointAt(0);
      if (code < 0x20 || supported.has(code)) { out += ch; continue; }
      const swap = REPLACEMENTS[ch];
      out += swap !== undefined && [...swap].every(c => supported.has(c.codePointAt(0))) ? swap : '?';
    }
    return out;
  };
  const encodeText = font.encodeText.bind(font);
  const widthOfTextAtSize = font.widthOfTextAtSize.bind(font);
  font.encodeText = (text) => encodeText(clean(text));
  font.widthOfTextAtSize = (text, size) => widthOfTextAtSize(clean(text), size);
  return font;
};
